var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ui-button", {
    attrs: {
      disabled: _vm.disabled,
      icon: _vm.showConfirm ? _vm.confirmIcon || _vm.icon : _vm.icon,
      floating: _vm.floating,
      primary: _vm.primary,
      raised: _vm.showConfirm,
      secondary: _vm.secondary,
      text: _vm.showConfirm ? _vm.confirmText || _vm.text : _vm.text,
      tooltip: _vm.tooltip,
      type: _vm.type,
    },
    on: { click: _vm.onClick, mouseleave: _vm.resetConfirm },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }